<template>
  <div>
    <h6 :class="[dark ? 'text-white' : '', 'text-center']">{{ title }}</h6>


    <div class="timeline timeline-one-side" :data-timeline-axis-style="dark ? 'dashed' : 'dotted'">
      <timeline-historico-cliente-item v-for="(items, key) of historico" :key="key" :items="items"
        :icon="{ component: 'ni ni-bell-55', color: 'success' }" :title="'Atualização'" :date-time="key"
        :badges="['ATUALIZAÇÃO']" />
    </div>
  </div>
</template>

<script>
import TimelineHistoricoClienteItem from "./TimelineHistoricoClienteItem.vue";
import api from "@/services/api";

export default {
  name: "TimelineHistoricoCliente",
  components: {
    TimelineHistoricoClienteItem,
  },
  props: {
    cliente: {
      type: Object,
      required: true,
      default: () => { },
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      historico: [],
    };
  },
  methods: {
    fetchData() {
      if (!this.cliente.id) {
        return;
      }

      api.get(`/clientes/${this.cliente.id}/historico`)
        .then(({ data }) => {
          this.historico = data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  watch: {
    cliente: {
      handler() {
        this.fetchData();
      },
      immediate: true,
    },
  },
};
</script>